import { Link } from "react-router-dom";
import { hotTags, articles } from "@/mocks/articles";

export default function TrendingSection() {
  const trendingArticle = articles.find((a) => a.id === "a9") || articles[0];

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Left - Image */}
            <div className="order-2 lg:order-1">
              <div className="rounded-3xl overflow-hidden shadow-xl">
                <img
                  src={trendingArticle.image}
                  alt={trendingArticle.title}
                  className="w-full aspect-[4/3] object-cover object-top"
                />
              </div>
            </div>

            {/* Right - Content */}
            <div className="order-1 lg:order-2">
              <span className="inline-flex items-center px-3 py-1.5 rounded-full bg-accent-100 text-accent-800 text-xs font-bold mb-5">
                <i className="ri-flashlight-line mr-1" />
                实时热搜
              </span>
              <h2 className="font-heading font-black text-foreground-950 text-3xl md:text-4xl leading-tight mb-4">
                {trendingArticle.title}
              </h2>
              <p className="text-foreground-600 text-base leading-relaxed mb-6">
                {trendingArticle.excerpt}
              </p>

              {/* Hot Tags */}
              <div className="mb-8">
                <h4 className="text-sm font-bold text-foreground-700 mb-3">热搜话题</h4>
                <div className="flex flex-wrap gap-2">
                  {hotTags.slice(0, 8).map((tag) => (
                    <span
                      key={tag}
                      className="inline-flex items-center px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium hover:bg-secondary-200 transition-colors cursor-pointer"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              <Link
                to={`/article/${trendingArticle.id}`}
                className="inline-flex items-center gap-3 px-6 py-3 rounded-xl bg-foreground-900 text-white text-sm font-medium hover:bg-foreground-800 transition-colors"
              >
                查看详情
                <i className="ri-arrow-right-up-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}